import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="border-t border-white/10 px-6 md:px-10 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-2 gap-12 items-end">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase text-qbprimary">The Dispatch</span>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.05] pb-1">
            First access to<br />every litter.
          </h2>
          <p className="text-qbfg/60 mt-6 max-w-md">
            Join the list for early reveals, lineage announcements and availability drops
            before they reach the public collection.
          </p>
        </div>
        <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
          <div className="flex flex-col sm:flex-row gap-3 border-b border-white/20 pb-3 focus-within:border-qbprimary transition-colors">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@lineage.com"
              data-testid="newsletter-email-input"
              className="flex-1 bg-transparent text-lg outline-none placeholder:text-qbfg/30 py-2"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-btn"
              className="px-7 py-3 rounded-full bg-qbprimary text-qbbg font-medium hover:bg-qbfg transition-colors disabled:opacity-50 whitespace-nowrap"
            >
              {loading ? "Joining…" : "Join the list"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};
